import { useCallback, useEffect, useMemo } from "react";

import { useQuery } from "hooks";
import createResolverFactory from "components/QueryClient/ResolverFactory";

import { createPlanInfo } from "./plans";

function usePlan(planId, withFallback = true) {
  const queryFactory = useCallback(() => {
    const query = `query plan($planId: String!, $withFallback: Boolean) {
        plan(planId: $planId, withFallback: $withFallback) {
          id
          name
          title
          featureList
          planOptions {
            planId
            name
            trial {
              period {
                length
                of
              }
            }
            pricing {
              currency
              monthlyPrice
              firstBillPrice
              billedToday
              billingPeriod
            }
          }
        }
      }`;

    const resolver = ({ data }) => {
      return data?.plan;
    };

    return { query: query, resolver: createResolverFactory(resolver) };
  }, []);

  const { data, error, ...q } = useQuery(
    queryFactory,
    useMemo(() => {
      return {
        variables: { planId, withFallback },
        options: { cached: true },
      };
    }, [planId, withFallback])
  );

  useEffect(() => {
    if (error) {
      console.error("usePlan", error?.[0]?.message || error);
    }
  }, [data, error]);

  return useMemo(() => {
    return {
      plans: error ? createPlanInfo() : data,
      error: error,
      loading: !error && (q.loading || q.numOfFetches === 0),
      ...q,
    };
  }, [error, data, q]);
}

export default usePlan;
